<template>
    <div>
      
            <h3 class="text-blue mt-2">Strategic Analysis Reporting</h3>
  
            <div class="row mt-4">
              <div class="col-sm-4">
                <label class="mr-4 font-weight-bold">Date Range</label>
                <flat-pickr
                  style="background: #efefef;opacity:1;text-align:center;color:#000"
                  placeholder=" All Time"
                  v-model="dateRange"
                  :config="dateOptions"
                ></flat-pickr>
              </div>
  
              <div class="col-sm-4">
                <label class="mr-4 font-weight-bold">Project</label>
                <select
                  style="opacity: 1 !important;background-color: #efefef;border: 0px; width: 160px; padding: 0px 20px;font-weight:700"
                  class=""
                >
                  <option>All Projects</option>
                  <option>Project 1</option>
                  <option>Project 2</option>
                  <option>Project 3</option>
                </select>
              </div>
  
              <div class="col-sm-4">
                <label class="mr-4 font-weight-bold">Sub Programmes</label>
                <select
                  style="opacity: 1 !important;background-color: #efefef;border: 0px; width: 160px; padding: 0px 20px;font-weight:700;font-weight:700"
                  class=""
                >
                  <option>All Sub Programmes</option>
                  <option>Sub Program 1</option>
                  <option>Sub Program 2</option>
                  <option>Sub Program 3</option>
                </select>
              </div>
            </div>
  
            <div class="row mt-4">
              <div class="col-sm-4">
                <label class="mr-3 font-weight-bold">All Provinces</label>
                <select
                  style="opacity: 1 !important;background-color: #efefef;border: 0px; width: 160px; padding: 0px 20px;font-weight:700;"
                  class=""
                >
                  <option>All Provinces</option>
                  <option>Province 1</option>
                  <option>Province 2</option>
                  <option>Province 3</option>
                </select>
              </div>
  
              <div class="col-sm-4">
                <label class="mr-4 font-weight-bold">Donor</label>
                <select
                  style="opacity: 1 !important;background-color: #efefef;border: 0px; width: 160px; padding: 0px 20px;font-weight:700"
                  class=""
                >
                  <option>All Donors</option>
                  <option>Donor 1</option>
                  <option>Donor 2</option>
                  <option>Donor 3</option>
                </select>
              </div>
            </div>
  
            <div class="row mt-5">
              <div class="col-lg-12 text-center mb-4">
                <div class=" line-bordered ">
                  <h6 class="mt-3 text-dark text-capitalize">
                    Trainings Over Time
                  </h6>
                  <div class="row mr-3" style="float:right">
                    <label class="mr-2 font-weight-bold mt-1"
                      >Time Duration</label
                    >
                    <span
                      style="background: #dcdcdc;opacity:1;color:#000;font-weight:700;padding:5px 30px"
                      >Monthly</span
                    >
                  </div>
                  <div
                    id="trainingsOverTime"
                    style="height: 450px; width: 100%;"
                  ></div>
                </div>
              </div>
  
              <div class="col-lg-12 text-center mb-4">
                <div class=" line-bordered ">
                  <h6 class="mt-3 text-dark text-capitalize">Donor Wise</h6>
                  <div id="donor" style="height: 450px; width: 100%;"></div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4 text-center mb-4">
                    <div class=" line-bordered ">
                      <h6 class="mt-3 text-dark text-capitalize">
                        Subprogram Wise
                      </h6>
                      <div
                        id="subProgram"
                        style="height: 450px; width: 100%;"
                      ></div>
                    </div>
                  </div>
                  <div class="col-lg-8 text-center mb-4">
                    <div class=" line-bordered ">
                      <h6 class="mt-3 text-dark text-capitalize">Project Wise</h6>
                      <div
                        id="projects"
                        style="height: 450px; width: 100%;"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-8 offset-lg-2 text-center mb-4">
                    <div class=" line-bordered ">
                      <h6 class="mt-3 text-dark text-capitalize">
                        Province Wise
                      </h6>
                      <div
                        id="province"
                        style="height: 450px; width: 100%;"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        
  </template>
  
  <script>
 
  import axios from "axios";
  import Highcharts from "../../../public/highcharts.js";
  // Import date picker css
  import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  
  export default {
    data: () => ({
      isActve1: 1,
      dateRange: [],
      colorx: "warning"
    }),
    components: {
      flatPickr,
    },
    created() {},
    methods: {
      openLoading() {
        this.$vs.loading({
          type: "material"
        });
      }
    },
     mounted() {
     axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        // Create the chart
  Highcharts.chart('trainingsOverTime', {
      chart: {
          type: 'column'
      },
      
      accessibility: {
          announceNewData: {
              enabled: true
          }
      },
      xAxis: {
          type: 'category',
           title: {
              text: '<b>Time</b>'
          }
      },
      yAxis: {
          title: {
              text: '<b>No. of Trainings<b>'
          }
  
      },
      legend: {
          enabled: false
      },
      plotOptions: {
          series: {
              borderWidth: 0,
              dataLabels: {
                  enabled: true,
                  format: '{point.y}'
              }
          }
      },
  
      tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.#333}">{point.name}</span>: <b>{point.y}</b><br/>'
      },
  
      series: [
          {
              name: "No. of Trainings",
              colorByPoint: false,
              data: [
                  {
                      name: "Jan",
                      y: 12,
                      color: "#d3d3d3"
                  },
                  {
                      name: "Feb",
                      y: 10,
                      color: "#00a4ea"
  
                  },
                  {
                      name: "March",
                      y: 17,
                      color: "#d3d3d3"
                  },
                  {
                      name: "April",
                      y: 15,
                      color: "#00a4ea"
                  },
                  {
                      name: "May",
                      y: 14,
                      color: "#d3d3d3"
                  },
                  {
                      name: "June",
                      y: 11,
                      color: "#00a4ea"
  
                  },
                  {
                      name: "July",
                      y: 19,
                       color: "#d3d3d3"
                  },
                  {
                      name: "Aug",
                      y: 13,
                      color: "#00a4ea"
                  },
                  {
                      name: "Sept",
                      y: 12,
                       color: "#d3d3d3"
  
                  },
                  {
                      name: "Oct",
                      y: 12,
                       color: "#00a4ea"
  
                  },
                  {
                      name: "Nov",
                      y: 13,
                        color: "#d3d3d3"
                  },
                  {
                      name: "Dec",
                      y: 11,
                       color: "#00a4ea"
                  }
              ]
          }
      ],
  
  });
  Highcharts.chart('donor', {
      chart: {
          type: 'column'
      },
      accessibility: {
          announceNewData: {
              enabled: true
          }
      },
      xAxis: {
          type: 'category',
           title: {
              text: '<b>Donor</b>'
          }
      },
      yAxis: {
          title: {
              text: '<b>No. of Trainings<b>'
          }
  
      },
      legend: {
          enabled: false
      },
      plotOptions: {
          series: {
              borderWidth: 0,
              dataLabels: {
                  enabled: true,
                  format: '{point.y}'
              }
          }
      },
  
      tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.#333}">{point.name}</span>: <b>{point.y}</b><br/>'
      },
  
      series: [
          {
              name: "No. of Trainings",
              colorByPoint: false,
              data: [
                  {
                      name: "Donor 1",
                      y: 12,
                      color: "#d3d3d3"
                  },
                  {
                      name: "Donor 2",
                      y: 10,
                      color: "#00a4ea"
  
                  },
                  {
                      name: "Donor 3",
                      y: 17,
                      color: "#d3d3d3"
                  },
                  {
                      name: "Donor 4",
                      y: 15,
                      color: "#00a4ea"
                  },
                  {
                      name: "Donor 5",
                      y: 14,
                      color: "#d3d3d3"
                  },
                  {
                      name: "Donor 6",
                      y: 11,
                      color: "#00a4ea"
  
                  },
                  {
                      name: "Donor 7",
                      y: 19,
                       color: "#d3d3d3"
                  },
                  {
                      name: "Donor 8",
                      y: 13,
                      color: "#00a4ea"
                  },
                  {
                      name: "Donor 9",
                      y: 12,
                       color: "#d3d3d3"
  
                  },
                  {
                      name: "Donor 10",
                      y: 13,
                        color: "#00a4ea"
                  },
                  {
                      name: "Donor 11",
                      y: 13,
                        color: "#d3d3d3"
                  },
                  {
                      name: "Donor 12",
                      y: 11,
                       color: "#00a4ea"
                  }
              ]
          }
      ],
  
  });
  Highcharts.chart('subProgram', {
      chart: {
          type: 'column'
      },
      accessibility: {
          announceNewData: {
              enabled: true
          }
      },
      xAxis: {
          type: 'category',
           title: {
              text: '<b>Sub Program</b>'
          }
      },
      yAxis: {
          title: {
              text: '<b>No. of Trainings<b>'
          }
  
      },
      legend: {
          enabled: false
      },
      plotOptions: {
          series: {
              borderWidth: 0,
              dataLabels: {
                  enabled: true,
                  format: '{point.y}'
              }
          }
      },
  
      tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.#333}">{point.name}</span>: <b>{point.y}</b><br/>'
      },
  
      series: [
          {
              name: "No. of Trainings",
              colorByPoint: false,
              data: [
                  {
                      name: "SP1",
                      y: 12,
                      color: "#d3d3d3"
                  },
                  {
                      name: "SP2",
                      y: 10,
                      color: "#00a4ea"
  
                  },
                  {
                      name: "SP3",
                      y: 17,
                      color: "#969696"
                  }
  
              ]
          }
      ],
  
  });
  Highcharts.chart('projects', {
      chart: {
          type: 'column'
      },
      accessibility: {
          announceNewData: {
              enabled: true
          }
      },
      xAxis: {
          type: 'category',
           title: {
              text: '<b>Projects</b>'
          }
      },
      yAxis: {
          title: {
              text: '<b>No. of Trainings<b>'
          }
  
      },
      legend: {
          enabled: false
      },
      plotOptions: {
          series: {
              borderWidth: 0,
              dataLabels: {
                  enabled: true,
                  format: '{point.y}'
              }
          }
      },
  
      tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.#333}">{point.name}</span>: <b>{point.y}</b><br/>'
      },
  
      series: [
          {
              name: "No. of Trainings",
              colorByPoint: false,
              data: [
                  {
                      name: "Poo1",
                      y: 12,
                      color: "#d3d3d3"
                  },
                  {
                      name: "Poo2",
                      y: 10,
                      color: "#00a4ea"
  
                  },
                  {
                      name: "Poo3",
                      y: 17,
                      color: "#969696"
                  },
                  {
                      name: "Poo4",
                      y: 15,
                      color: "#7bd7ff"
                  },
                  {
                      name: "Poo5",
                      y: 14,
                      color: "#d3d3d3"
                  },
                  {
                      name: "Poo6",
                      y: 11,
                      color: "#00a4ea"
  
                  },
                  {
                      name: "Poo7",
                      y: 19,
                       color: "#969696"
                  },
                  {
                      name: "Poo8",
                      y: 13,
                      color: "#7bd7ff"
                  },
                  {
                      name: "Poo9",
                      y: 12,
                       color: "#d3d3d3"
  
                  },
                  {
                      name: "Poo10",
                      y: 5,
                        color: "#00a4ea"
                  },
                  {
                      name: "Poo11",
                      y: 4,
                        color: "#969696"
                  },
                  {
                      name: "Poo12",
                      y: 9,
                       color: "#7bd7ff"
                  }
  
              ]
          }
      ],
  
  });
  Highcharts.chart('province', {
      chart: {
          type: 'column'
      },
      accessibility: {
          announceNewData: {
              enabled: true
          }
      },
      xAxis: {
          type: 'category',
           title: {
              text: '<b>Province</b>'
          }
      },
      yAxis: {
          title: {
              text: '<b>No. of Trainings<b>'
          }
  
      },
      legend: {
          enabled: false
      },
      plotOptions: {
          series: {
              borderWidth: 0,
              dataLabels: {
                  enabled: true,
                  format: '{point.y}'
              }
          }
      },
  
      tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.#333}">{point.name}</span>: <b>{point.y}</b><br/>'
      },
  
      series: [
          {
              name: "No. of Trainings",
              colorByPoint: false,
              data: [
                  {
                      name: "Sindh",
                      y: 12,
                      color: "#d3d3d3"
                  },
                   {
                      name: "KPK",
                      y: 15,
                      color: "#7bd7ff"
                  },
                  {
                      name: "Punjab",
                      y: 10,
                      color: "#00a4ea"
  
                  },
                  {
                      name: "Balochistan",
                      y: 17,
                      color: "#969696"
                  },
  
                   {
                      name: "Gilgit Baltistan",
                      y: 15,
                      color: "#7bd7ff"
                  },
                  {
                      name: "Kashmir",
                      y: 15,
                      color: "#7bd7ff"
                  },
  
              ]
          }
      ],
  
  });
    }
  };
  </script>
  
  <style scoped>
  .text-blue {
    color: #00a4ea;
  }
  .btn-report {
    background-color: #6488d2 !important;
    border-radius: 0px !important;
    padding: 3px 30px !important;
  }
  .table th, .table td{
      width:10%
  }
  ::placeholder{
      border: 0px;
      font-weight: 700;
      text-align: center;
      margin: 0px;
      color:#000;
  }
  
  input.flatpickr-input{
       border: 0px;
      font-weight: 700;
      text-align: center;
      margin: 0px;
      color:#000;
  }
  
  .line-bordered {
    border-top: 2px solid #6c757d;
    border-bottom: 2px solid #6c757d;
    border-left: 1px solid #6c757d;
    border-right: 1px solid #6c757d;
  }
  </style>
  